import Vue from "vue";
import "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Toaster from "v-toaster";
import "v-toaster/dist/v-toaster.css";
import VueProgressBar from "vue-progressbar";
import VueHtmlToPaper from 'vue-html-to-paper';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import Lightbox from 'vue-easy-lightbox';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import ReadMore from 'vue-read-more';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueAnalytics from 'vue-analytics';
import vuescroll from "vuescroll/dist/vuescroll-native";
import "vuescroll/dist/vuescroll.css";
import VueGeolocation from 'vue-browser-geolocation';
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import Embed from 'v-video-embed';
import vuetify from './plugins/vuetify'
import VueMeta from 'vue-meta'
// import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-2';

const printOptions = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};

const options = {
  color: "#03A9F4",
  failedColor: "#F44336",
  thickness: "3px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
};

Vue.use(VueGoogleMaps, {
  load: {
    key: '',
    libraries: 'places',
  },
});

Vue.use(VueProgressBar, {
  color: "#2D76D2",
  failedColor: "red",
  height: "3px"
});
Vue.use(Toaster, {
  timeout: 5000
});
library.add(fas);
library.add(fab);
Vue.component('multiselect', Multiselect);
Vue.use(VueHtmlToPaper, printOptions);
Vue.use(VueProgressBar, options);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(Lightbox);
Vue.use(Embed);
Vue.use(vuescroll);
Vue.prototype.moment = moment;

Vue.use(Vuetify);
Vue.use(ReadMore);
Vue.use(VueGeolocation);

Vue.use(VueMeta);


Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyBRjO5vAPG07YlVfoOE1Vi3jesaA8azIJk', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  version: '...', // Optional
  language: '...', // Optional
});

Vue.use(VueGoogleAutocomplete, {
  apiKey: 'AIzaSyBRjO5vAPG07YlVfoOE1Vi3jesaA8azIJk', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  version: '...', // Optional
  language: '...', // Optional
});

Vue.use(VueAnalytics, {
  id: 'G-BK97M5XJ5K',
  router
});

// Vue.use(TawkMessengerVue, {
//   propertyId : '63bfd8d0c2f1ac1e202d0abd',
//   widgetId : '1gmimdsgb'
// });

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false;
const token = sessionStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = token;
}
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
